import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetPaginationRes } from '@pp/core/entities';

import { Rates } from './rate-conditions';
import { ApiSettings } from './shell.entities';

export interface ShellApiInterface {
  getRates(): Observable<GetPaginationRes<Rates>>;
  getCryptoMarket(): Observable<GetPaginationRes<any>>;
  getTotalBalance(currencyId: number): Observable<string>;
  getSettings(): Observable<ApiSettings>;
  changeAgentFeatureAvailability(agent_feature_availability: boolean): Observable<void>;
  generateTelegramLink(orgId: number | unknown): Observable<string>;
}

export const SHELL_API = new InjectionToken<ShellApiInterface>('SHELL_API');
